import React from "react";
import { withTranslation } from "react-i18next";

import ClimateBookletImage from "../../assets/images/quiz/myclimate_Klimabooklet_2020_Cover_RGB.jpg";

const QuizEvaluation = ({
  t,
  previous,
  correctAnswersCount,
  totalCount,
  resultCategory,
}) => (
  <>
    <h1>{t("quiz.evaluation.title")}</h1>

    <div
      style={{
        display: "flex",
        flexDirection: "column",
        fontWeight: "bold",
      }}
    >
      <div style={{ fontSize: "1.25rem" }}>{t("quiz.evaluation.points")}</div>
      <div style={{ marginTop: "2rem", fontSize: "4rem" }}>
        {correctAnswersCount}/{totalCount}
      </div>
    </div>

    <div style={{ marginTop: "3rem" }}>
      <div style={{ fontSize: "2rem", color: "#e6007e" }}>
        <strong>{t(`quiz.evaluation.${resultCategory}.title`)}</strong>
      </div>
      <div style={{ marginTop: "1rem" }}>
        {t(`quiz.evaluation.${resultCategory}.description`)}
      </div>
    </div>

    <div style={{ marginTop: "2rem" }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={ClimateBookletImage}
          style={{ maxWidth: "7rem", marginRight: "1rem" }}
        />
        <strong>{t("quiz.evaluation.climate_booklet_description")}</strong>
      </div>
      <div
        style={{
          display: "flex",
          marginTop: "1rem",
        }}
      >
        <form action={t("quiz.evaluation.climate_booklet_url")} method="GET">
          <input type="hidden" name="q" value="myclimate klimabooklet" />
          <input
            type="submit"
            className="btn btn-info"
            value={t("quiz.evaluation.climate_booklet_action")}
          />
        </form>
      </div>
    </div>

    <div style={{ marginTop: "2rem" }}>
      <button className="btn btn-primary" onClick={() => previous()}>
        {t("quiz.previous")}
      </button>
    </div>
  </>
);

export default withTranslation()(QuizEvaluation);
